import { useSyncExternalStore } from 'react'
import { getDeskOrg, watchDeskOrg } from '../api/client'

/** The help desk the widget is open in, as a value a component can render. */
export function useDeskOrg() {
  return useSyncExternalStore(watchDeskOrg, getDeskOrg, () => '')
}
